module.exports = __webpack_public_path__ + "assets/img/footer_logo_1.6838f069.png";